const isEmpty = (value: unknown): boolean => {
  if (value === null || value === undefined) return true;

  if (typeof value === "string" || Array.isArray(value)) {
    return value.length === 0;
  }

  if (typeof value === "object") {
    return Object.keys(value as Record<string, unknown>).length === 0;
  }

  return false;
};

export default isEmpty;
